<script type="text/jsx">
import partnerEntryMixin from '@/views/config/partner-refer/mixin/partner-entry';

export default {
  name: 'partner-plan-card',
  mixins: [partnerEntryMixin],
  render() {
    const Comp = this.getPlanCardContent();
    return Comp ? <Comp class="partner-plan-card__wrapper" /> : null;
  },
};
</script>

<style lang="scss">
@import '@/styles/_variables.scss';

.partner-plan-card {
  &__skeleton--wrapper {
    .zm-skeleton {
      margin-top: 16px;
    }
  }

  &__wrapper {
    margin-top: 16px;
  }
}

.opc-partner-open-offer-detail {
  white-space: nowrap;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  text-align: left;
  color: #0B5CFF;
}
</style>

